var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root-wrap"},[_c('div',{staticClass:"fx-fill fx-center-middle"},[_c('van-empty',{attrs:{"image":require('@/assets/images/error/404.png'),"description":"您的页面丢失了"}}),_c('div',{staticStyle:{"padding":"20px","word-break":"break-all"}},[_c('div',[_vm._v("FM")]),_c('div',[_vm._v(_vm._s(_vm.href))])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }